export const ALPHABET = "abcdefghijklmnopqrst";

export function makeid(length: number) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

export function dropNum(num: number, dot: boolean = false) {
  let str = `${num}`
  let splitIndex = (str.length + 2) % 3 + 1;
  str = str.slice(0, splitIndex) + str.slice(splitIndex).replace(/\d\d\d/g, `${dot ? "." : " "}$&`)
  return str
}

export const replImage = (str: string) => {
  if (str === undefined) 
    return ""
  let spl = str.split(";")
  if (spl.length > 0) {
    return spl[0].replace("https://api.topgun.ru/core/image/", "https://xn--e1aybc.xn--b1aogkgnb5h.xn--p1ai/uploads/images/")
  }
  return ""
}

export const getSubName = (name: string) => {
  if (name == "sub1") {
    return "БАЗА"
  } else if (name == "sub2") {
    return "ПЛЮС"
  } else if (name == "sub3") {
    return "ПРО"
  } else if (name == "sub4") {
    return "ТОП"
  } else if (name == "barber") {
    return "БАРБЕР"
  } else if (name == "barber_plus") {
    return "БАРБЕР ПЛЮС"
  }
}

export function prevent(ev: any) {
  ev.preventDefault()
  ev.stopPropagation()
}

export function isElementInViewport(el?: any | null): boolean {
  if (el == undefined || el == null) {
    return false
  }
  
  let top = el.offsetTop, left = el.offsetLeft,
      width = el.offsetWidth, height = el.offsetHeight

  while (el!.offsetParent) {
    el = el!.offsetParent
    top += el.offsetTop
    left += el.offsetLeft
  }
  
  return (
    top < (window.pageYOffset + window.innerHeight) &&
    left < (window.pageXOffset + window.innerWidth)
  )
}

export const fixNumber = (num: number) => num < 10 ? `0${num}` : `${num}`

export const buildParams = (map: any) => {
  let query = ""
  for (let key in map) {
    if (query == "") {
      query = `?${key}=${map[key]}`
    } else {
      query += `&${key}=${map[key]}`
    }
  }
  return query
}

export function urlify(text: string) {
  var urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.replace(urlRegex, function(url) {
    return '<a href="' + url + '" target="_blank">' + url + '</a>';
  })
}

export function isNullOrUndefined<T>(obj: T | null | undefined): obj is null | undefined {
  return typeof obj === "undefined" || obj === null;
}

export async function asyncForEach<T>(array: T[], callback: (item: T, index: number, array: T[]) => Promise<T> | void | null) {
  for (let index = 0; index < array.length; index++) {
    if (callback != null) {
      await callback(array[index], index, array)
    }
  }
}

export const declOfNum = (n: number, text_forms: string[]) => {  
  n = Math.abs(n) % 100
  let n1 = n % 10
  if (n > 10 && n < 20) { return text_forms[2] }
  if (n1 > 1 && n1 < 5) { return text_forms[1] }
  if (n1 == 1) { return text_forms[0] }
  return text_forms[2]
}

export function translit(word: string) {
  let answer: string = ""
  const converter: any = {
    'а': 'a',    'б': 'b',    'в': 'v',    'г': 'g',    'д': 'd',
    'е': 'e',    'ё': 'e',    'ж': 'zh',   'з': 'z',    'и': 'i',
    'й': 'y',    'к': 'k',    'л': 'l',    'м': 'm',    'н': 'n',
    'о': 'o',    'п': 'p',    'р': 'r',    'с': 's',    'т': 't',
    'у': 'u',    'ф': 'f',    'х': 'h',    'ц': 'c',    'ч': 'ch',
    'ш': 'sh',   'щ': 'sch',  'ь': '',     'ы': 'y',    'ъ': '',
    'э': 'e',    'ю': 'yu',   'я': 'ya',
 
    'А': 'A',    'Б': 'B',    'В': 'V',    'Г': 'G',    'Д': 'D',
    'Е': 'E',    'Ё': 'E',    'Ж': 'Zh',   'З': 'Z',    'И': 'I',
    'Й': 'Y',    'К': 'K',    'Л': 'L',    'М': 'M',    'Н': 'N',
    'О': 'O',    'П': 'P',    'Р': 'R',    'С': 'S',    'Т': 'T',
    'У': 'U',    'Ф': 'F',    'Х': 'H',    'Ц': 'C',    'Ч': 'Ch',
    'Ш': 'Sh',   'Щ': 'Sch',  'Ь': '',     'Ы': 'Y',    'Ъ': '',
    'Э': 'E',    'Ю': 'Yu',   'Я': 'Ya',  '  ': '',  ' ': '-', '.': '', ',': ''
  }
  for (let i = 0; i < word.length; ++i) {
    if (converter[word[i]] == undefined){
      answer += word[i]
    } else {
      answer += converter[word[i]]
    }
  }
  return answer
}

export function getOS() {
  const userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['macOS', 'Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod']
  let os = null
  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS'
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS'
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows'
  } else if (/Android/.test(userAgent)) {
    os = 'Android'
  } else if (/Linux/.test(platform)) {
    os = 'Linux'
  }
  return os
}